import { gql } from '@apollo/client';

export const CREATE_PROFILE_MESSAGE_THREAD = gql`
  mutation CreateProfileThread($userId: ID!) {
    createProfileMessageThread(input: { userId: $userId }) {
      messageThread {
        id
        subject
        participants {
          id
          name
        }
      }
      errors
    }
  }
`;
